module.exports = __webpack_public_path__ + "img/check-circle.64d70a17.png";